(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      super.hide();
      window.pauseAllMedia();
    }
    show(opener) {
      super.show(opener);
      //this.showActiveMedia();
      this.constProductPageSwiperCall();
    }
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
    constProductPageSwiperCall(showActiveMedia) {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      let activeMediaIndex = 0;
      const modalSwiperElement = this.querySelector('#product-page-swiper, #featured-product-swiper');
      const nextButton = this.querySelector('.swiper-button-next-prod-page');
      const prevButton = this.querySelector('.swiper-button-prev-prod-page');
      const closeButton = this.querySelector('.product-media-modal__toggle');
      if (!modalSwiperElement) return;
      this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
        if (element == activeMedia) {
          activeMediaIndex = index;
        }
      });
      const prodPageSwiper = new Swiper(modalSwiperElement, {
        zoom: true,
        centeredSlides: false,
        slidesPerView: 1,
        autoheight: true,
        watchSlidesVisibility: false,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        init: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
      });
      prodPageSwiper.on('init', function () {
        prodPageSwiper.slideTo(activeMediaIndex, 0, false);
      });
      prodPageSwiper.init();
      if (closeButton) {
        closeButton.addEventListener(
          'click',
          function () {
            prodPageSwiper.destroy();
          },
          { once: true }
        );
      }
    }
  }
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', ProductModal);
  }
  if (!customElements.get('product-recommendations--single')) {
    customElements.define('product-recommendations--single', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }
    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }
    connectedCallback() {
      this.handleClickOutside = this.handleClickOutside.bind(this);
      document.addEventListener('click', this.handleClickOutside);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.handleClickOutside);
    }
    handleClickOutside(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.headerId = document.getElementById('section-header').getAttribute('data-header-id');
      this.header = document.getElementById(`shopify-section-${this.headerId}`);
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
        if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
          this.predictiveSearch.onFocusOut();
          this.predictiveSearch.onBlur();
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }
    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.header.classList.contains('header-overlay')) {
        this.header.classList.remove('color-background-4');
        this.header.classList.add('overlay-effect');
        this.header.classList.remove('color-background-overlay');
      }
      const headerMobile = document.querySelector('.header-mobile-section');
      if (headerMobile.classList.contains('header-overlay')) {
        headerMobile.classList.remove('color-background-4');
        headerMobile.classList.add('overlay-effect');
        headerMobile.classList.remove('color-background-overlay');
      }
    }
    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      const headerMobile = document.querySelector('.header-mobile-section');
      if (this.header.classList.contains('header-overlay')) {
        this.header.classList.add('color-background-4');
        this.header.classList.remove('color-background-1');
        this.header.classList.remove('overlay-effect');
        this.header.classList.add('color-background-overlay');
      }
      if (headerMobile.classList.contains('header-overlay')) {
        headerMobile.classList.add('color-background-4');
        headerMobile.classList.remove('color-background-1');
        headerMobile.classList.remove('overlay-effect');
        headerMobile.classList.add('color-background-overlay');
      }
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      super.hide();
      window.pauseAllMedia();
    }
    show(opener) {
      super.show(opener);
      //this.showActiveMedia();
      this.constProductPageSwiperCall();
    }
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
    constProductPageSwiperCall(showActiveMedia) {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      let activeMediaIndex = 0;
      const modalSwiperElement = this.querySelector('#product-page-swiper, #featured-product-swiper');
      const nextButton = this.querySelector('.swiper-button-next-prod-page');
      const prevButton = this.querySelector('.swiper-button-prev-prod-page');
      const closeButton = this.querySelector('.product-media-modal__toggle');
      if (!modalSwiperElement) return;
      this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
        if (element == activeMedia) {
          activeMediaIndex = index;
        }
      });
      const prodPageSwiper = new Swiper(modalSwiperElement, {
        zoom: true,
        centeredSlides: false,
        slidesPerView: 1,
        autoheight: true,
        watchSlidesVisibility: false,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        init: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: '.swiper-pagination-product-page',
          clickable: true,
        },
        //on: {
        //	click: function (e) {
        //			if (this.zoom.scale === 1) {
        //			this.zoom.in();
        //			} else {
        //				this.zoom.out();
        //			}
        //	 },
        //},
      });
      prodPageSwiper.on('init', function () {
        prodPageSwiper.slideTo(activeMediaIndex, 0, false);
      });
      prodPageSwiper.init();
      if (closeButton) {
        closeButton.addEventListener(
          'click',
          function () {
            prodPageSwiper.destroy();
          },
          { once: true }
        );
      }
    }
  }
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', ProductModal);
  }
  if (!customElements.get('product-recommendations--single')) {
    customElements.define('product-recommendations--single', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function appHeight() {
      const doc = document.documentElement;
      doc.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
    }

    //window.addEventListener('resize', appHeight);
    appHeight();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-teamwear-catalogue"] && !Shopify.designMode) return;
  try {
    
function initTeamwearCatalogue(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const products=[...root.querySelectorAll('[data-products]')].flatMap(el=>JSON.parse(el.textContent));
products.sort((a,b)=>{const rank=p=>(['Entrada 26','Park 26','Strike 26','teamLIGA','Championship 20°','Active'].includes(p.range)?0:100)+(p.variants.some(v=>v.audience==='Adult'||v.audience==='Unisex')?0:10)+(p.category==='T-Shirts & Jerseys'?0:p.category==='Shorts'?1:p.category==='Training Tops'?2:3);return rank(a)-rank(b);});
const images=Object.assign({},...[...root.querySelectorAll('[data-images]')].map(el=>JSON.parse(el.textContent)));
for(const p of products)for(const v of p.variants)v.imageSource=(images[v.image]||'').startsWith('data:')?'catalogue':'adidas';
const L=JSON.parse(root.querySelector('[data-labels]').textContent),get=s=>root.querySelector(s),money=n=>new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(n),key='ws-teamwear-'+root.dataset.brand.toLowerCase()+'-request-v2';
const catalogueReference=Object.assign({},...[...root.querySelectorAll('[data-catalogue-reference]')].map(el=>JSON.parse(el.textContent)));
const reference=v=>catalogueReference[v.code+'|'+v.audience]||catalogueReference[v.code];
const variantKey=v=>v.code+'|'+v.audience;
const vatSize=(v,size)=>v.vatSizes?.includes(size)||(root.dataset.brand==='adidas'&&v.audience==='Junior'&&['15–16 Years','176'].includes(size));
const sizePrice=(v,size)=>v.sizePrices?.[size]??(v.price===null?null:Math.round(v.price*(vatSize(v,size)?120:100))/100);
const sizeRrp=(v,size)=>v.sizeRrps?.[size]??(reference(v)?.r?Math.round(reference(v).r*(vatSize(v,size)?120:100))/100:null);
const priceRange=values=>{const nums=[...new Set(values.filter(x=>x!==null&&x!==undefined))].sort((a,b)=>a-b);return nums.length?money(nums[0])+(nums.length>1?'–'+money(nums.at(-1)):''):L.priceRequest;};
const byCode=new Map(products.flatMap(p=>p.variants.map(v=>[variantKey(v),{p,v}])));
let basket=[],current=null,selected=null,limit=24;
const node=(tag,text,cls)=>{const n=document.createElement(tag);if(text!==undefined)n.textContent=text;if(cls)n.className=cls;return n;};
const normal=s=>s.toLowerCase().replace(/[-–’']/g,'').trim();
const option=(label,value)=>{const o=node('option',label);o.value=value;return o;};
const groupColour=s=>{const t=s.toLowerCase().split('/')[0];return t.includes('navy')||t.includes('obsidian')?'Navy':t.includes('blue')||t.includes('royal')?'Blue':t.includes('black')?'Black':t.includes('white')?'White':t.includes('grey')||t.includes('onix')?'Grey':t.includes('bottle')||t.includes('green')||t.includes('mint')||t.includes('lime')?'Green':t.includes('yellow')||t.includes('lemon')?'Yellow':t.includes('orange')?'Orange':t.includes('pink')||t.includes('magenta')?'Pink':t.includes('purple')||t.includes('violet')?'Purple':t.includes('maroon')||t.includes('burgundy')?'Burgundy':t.includes('red')||t.includes('ruby')?'Red':'Other';};
try{const saved=JSON.parse(localStorage.getItem(key)||'null');if(Array.isArray(saved))basket=saved;else{const old=JSON.parse(root.dataset.brand==='adidas'?localStorage.getItem('ws-teamwear-adidas-request-v1')||'[]':'[]'),codes={jersey:{Adult:'JZ2505',Junior:'JZ2524'},tee:{Adult:'JZ6676',Junior:'JZ6674'},shorts:{Adult:'JZ2521',Junior:'JZ6531'},polo:{Adult:'JZ6660',Junior:'JZ6629'},training:{Adult:'JZ6658',Junior:'JZ6630'},jacket:{Adult:'JZ6587',Junior:'JZ6608'},pants:{Adult:'KE9848',Junior:'JZ6550'}};basket=old.map(l=>({code:codes[l.id]?.[l.audience],size:l.size,quantity:l.quantity}));}basket=basket.map(l=>({...l,variantId:l.variantId||[...byCode.keys()].find(k=>k.startsWith(l.code+'|'))})).filter(l=>byCode.has(l.variantId)&&byCode.get(l.variantId).v.sizes.includes(l.size)&&Number.isInteger(l.quantity)&&l.quantity>0&&l.quantity<=999);}catch(e){basket=[];}
for(const c of [...new Set(products.map(p=>p.category))].sort())get('#twc-category').append(option(c,c));
for(const r of [...new Set(products.map(p=>p.range))].sort())get('#twc-range').append(option(r,r));
for(const c of [...new Set(products.flatMap(p=>p.variants.map(v=>groupColour(v.colour))))].sort())get('#twc-colour-filter').append(option(c,c));
function setImage(el,v,p){el.src=images[v.image];el.alt=p.name+' · '+v.colour;el.dataset.quality=v.imageSource==='catalogue'?'catalogue':'photo';}
function eligible(p){const age=get('#twc-audience').value,colour=get('#twc-colour-filter').value;return p.variants.filter(v=>(!age||v.audience===age||v.audience==='Unisex')&&(!colour||groupColour(v.colour)===colour));}
function filtered(){const query=normal(get('#twc-search').value).split(/\s+/).filter(Boolean),cat=get('#twc-category').value,range=get('#twc-range').value;let list=products.map(p=>({p,variants:eligible(p)})).filter(({p,variants})=>variants.length&&(!cat||p.category===cat)&&(!range||p.range===range)&&query.every(term=>normal([p.name,p.category,p.range,...variants.flatMap(v=>[v.colour,v.code,v.audience])].join(' ')).includes(term)));const sort=get('#twc-sort').value,min=row=>Math.min(...row.variants.flatMap(v=>v.sizes.map(size=>sizePrice(v,size)??Infinity)));if(sort==='name')list.sort((a,b)=>a.p.name.localeCompare(b.p.name));if(sort==='low')list.sort((a,b)=>min(a)-min(b));if(sort==='high')list.sort((a,b)=>min(b)-min(a));return list;}
function renderCards(){const list=filtered();get('[data-grid]').replaceChildren();get('[data-count]').textContent=list.length+' '+(list.length===1?L.style:L.styles);get('[data-no-results]').hidden=list.length>0;for(const {p,variants} of list.slice(0,limit)){const q=normal(get('#twc-search').value),primary=variants.find(v=>q.includes(normal(v.code)))||variants.find(v=>v.imageSource!=='catalogue')||variants[0],card=node('article',undefined,'twc__card'),img=node('img');setImage(img,primary,p);img.width=500;img.height=500;img.loading='lazy';const media=node('button',undefined,'twc__image-button');media.type='button';media.setAttribute('aria-label',L.select+' '+p.name);media.append(img);media.addEventListener('click',()=>openProduct(p,primary));card.append(media,node('h2',p.name),node('p',[...new Set(variants.map(v=>v.audience))].map(a=>L[a.toLowerCase()]||a).join(' / ')));const colours=[...new Map(variants.map(v=>[v.colour,v])).values()],swatches=node('div',undefined,'twc__card-colours');for(const v of colours.slice(0,6)){const b=node('button'),thumb=node('img');b.type='button';b.title=v.colour;b.setAttribute('aria-label',p.name+' · '+v.colour);setImage(thumb,v,p);thumb.loading='lazy';thumb.width=36;thumb.height=36;b.append(thumb);b.addEventListener('click',()=>openProduct(p,v));swatches.append(b);}if(colours.length>6)swatches.append(node('span','+'+(colours.length-6)));card.append(swatches);const prices=[...new Set(variants.flatMap(v=>v.sizes.map(size=>sizePrice(v,size))).filter(v=>v!==null))];const priceGroup=node('div',undefined,'twc__prices');priceGroup.append(node('p',L.ourPrice+' '+(prices.length?(prices.length>1?L.from+' ':'')+money(Math.min(...prices)):L.priceRequest),'twc__price'));const refs=variants.map(v=>reference(v)).filter(r=>r?.r),rrps=[...new Set(variants.flatMap(v=>v.sizes.map(size=>sizeRrp(v,size))).filter(Boolean))].sort((a,b)=>a-b);if(rrps.length){const line=node('p',undefined,'twc__rrp'),label=refs.every(r=>r.label===refs[0].label)&&refs[0]?.label?refs[0].label:refs.every(r=>r.s==='catalogue')?L.catalogueRrp:L.rrp;line.append(node('span',label+' '));line.append(node(variants.every(v=>v.price!==null&&reference(v)?.r>v.price)?'s':'span',money(rrps[0])+(rrps.length>1?'–'+money(rrps.at(-1)):'')));priceGroup.append(line);}card.append(priceGroup);const b=node('button',L.select,'twc__button');b.type='button';b.addEventListener('click',()=>openProduct(p,primary));card.append(b);get('[data-grid]').append(card);}get('[data-load-more]').hidden=limit>=list.length;get('[data-showing]').textContent=list.length?L.showing+' '+Math.min(limit,list.length)+' '+L.of+' '+list.length:'';}
function sizes(){get('span[data-code]').textContent=selected.code;get('[data-product-price]').textContent=L.ourPrice+' '+priceRange(selected.sizes.map(size=>sizePrice(selected,size)));const ref=reference(selected),rrp=get('[data-product-rrp]');rrp.replaceChildren();if(ref?.r){rrp.append(node('span',(ref.label||(ref.s==='catalogue'?L.catalogueRrp:L.rrp))+' '),node(selected.price!==null&&selected.price<ref.r?'s':'span',priceRange(selected.sizes.map(size=>sizeRrp(selected,size)))));}get('[data-rrp-note]').hidden=ref?.s!=='manufacturer';get('[data-rrp-note]').textContent=L.rrpCorrection;get('[data-lifecycle]').textContent=ref?.end?L.plannedEnd+' '+ref.end:ref?.y?L.plannedEnd+' '+L.february+' '+ref.y:L.lifecycleUnknown;get('[data-colour]').textContent=selected.colour;get('[data-reference]').textContent=selected.imageSource==='catalogue'?L.catalogueImage:L.reference;setImage(get('[data-product-image]'),selected,current);get('[data-sizes]').replaceChildren();selected.sizes.forEach((size,i)=>{const wrap=node('div'),label=node('label',size),input=node('input');input.type='number';input.min='0';input.max='999';input.step='1';input.value='0';input.dataset.size=size;input.id='twc-size-'+i;label.htmlFor=input.id;const price=node('small',priceRange([sizePrice(selected,size)]),'twc__size-price');if(vatSize(selected,size))price.append(node('span',' · '+L.vatIncluded));const rrp=sizeRrp(selected,size);if(rrp)price.append(node('span',(reference(selected)?.label||L.rrp)+' '+money(rrp),'twc__size-rrp'));wrap.append(label,price,input);get('[data-sizes]').append(wrap);});get('[data-add-status]').textContent='';for(const b of get('[data-colour-options]').querySelectorAll('button'))b.setAttribute('aria-pressed',String(b.dataset.code===selected.code));}
function colours(preferred){const age=get('#twc-product-audience').value,variants=current.variants.filter(v=>v.audience===age);selected=variants.find(v=>v.colour===preferred)||variants[0];get('[data-colour-options]').replaceChildren();for(const v of variants){const b=node('button'),img=node('img');b.type='button';b.title=v.colour;b.dataset.code=v.code;b.setAttribute('aria-label',v.colour);img.width=60;img.height=60;img.loading='lazy';setImage(img,v,current);b.append(img);b.addEventListener('click',()=>{selected=v;sizes();});get('[data-colour-options]').append(b);}sizes();}
function openProduct(p,v){current=p;get('#twc-product-title').textContent=p.name;get('[data-product-range]').textContent=p.range;get('[data-description]').textContent=p.description;get('[data-spec]').textContent=p.specification;get('#twc-product-audience').replaceChildren(...[...new Set(p.variants.map(v=>v.audience))].map(a=>option(L[a.toLowerCase()]||a,a)));get('#twc-product-audience').value=v.audience;colours(v.colour);get('[data-product-dialog]').showModal();}
function renderBasket(){const area=get('[data-basket]');area.replaceChildren();let sum=0;const summary=[L.requestHeading];if(!basket.length)area.append(node('p',L.empty));basket.forEach((line,index)=>{const {p,v}=byCode.get(line.variantId),unit=sizePrice(v,line.size),row=node('div',undefined,'twc__line'),text=node('div');if(unit!==null)sum+=Math.round(unit*100)*line.quantity;text.append(node('strong',p.name),node('p',(L[v.audience.toLowerCase()]||v.audience)+' · '+v.colour+' · '+line.size+' × '+line.quantity),node('p',v.code+' · '+(unit===null?L.pending:money(Math.round(unit*100)*line.quantity/100))));const remove=node('button',L.remove);remove.type='button';remove.setAttribute('aria-label',L.remove+' '+v.code+' '+line.size);remove.addEventListener('click',()=>{basket.splice(index,1);renderBasket();});row.append(text,remove);area.append(row);summary.push(p.name+' | '+v.audience+' | '+v.colour+' | '+v.code+' | '+line.size+' | Qty '+line.quantity+' | '+(unit===null?L.pending:money(unit)+' '+L.each+(vatSize(v,line.size)?' · '+L.vatIncluded:'')));});get('[data-subtotal]').textContent=money(sum/100);get('[data-basket-count]').textContent=basket.reduce((n,l)=>n+l.quantity,0);if(get('#twc-summary'))get('#twc-summary').value=basket.length?summary.join('\n'):'';if(get('[data-send]'))get('[data-send]').disabled=!basket.length;try{localStorage.setItem(key,JSON.stringify(basket));}catch(e){}}
get('[data-size-form]').addEventListener('submit',event=>{event.preventDefault();const inputs=[...get('[data-sizes]').querySelectorAll('input')];if(inputs.some(i=>!Number.isInteger(Number(i.value))||Number(i.value)<0||Number(i.value)>999)){get('[data-add-status]').textContent=L.invalidQuantity;return;}const chosen=inputs.filter(i=>Number(i.value)>0);if(!chosen.length){get('[data-add-status]').textContent=L.needQuantity;return;}if(chosen.some(i=>{const existing=basket.find(l=>l.variantId===variantKey(selected)&&l.size===i.dataset.size);return (existing?.quantity||0)+Number(i.value)>999;})){get('[data-add-status]').textContent=L.invalidQuantity;return;}for(const i of chosen){const existing=basket.find(l=>l.variantId===variantKey(selected)&&l.size===i.dataset.size);if(existing)existing.quantity+=Number(i.value);else basket.push({variantId:variantKey(selected),code:selected.code,size:i.dataset.size,quantity:Number(i.value)});i.value='0';}renderBasket();get('[data-add-status]').textContent=L.added;});
get('[data-close]').addEventListener('click',()=>get('[data-product-dialog]').close());get('#twc-product-audience').addEventListener('change',()=>colours(selected.colour));
for(const sel of ['#twc-search','#twc-category','#twc-audience','#twc-range','#twc-colour-filter','#twc-sort'])get(sel).addEventListener(sel==='#twc-search'?'input':'change',()=>{limit=24;renderCards();});
get('[data-reset]').addEventListener('click',()=>{for(const sel of ['#twc-search','#twc-category','#twc-audience','#twc-range','#twc-colour-filter','#twc-sort'])get(sel).value='';limit=24;renderCards();});get('[data-load-more]').addEventListener('click',()=>{limit+=24;renderCards();});get('[data-clear]').addEventListener('click',()=>{basket=[];renderBasket();});if(get('[data-success]'))basket=[];get('#TeamwearCatalogueContact')?.addEventListener('submit',e=>{if(!basket.length)e.preventDefault();else renderBasket();});renderCards();renderBasket();
}
document.querySelectorAll('[data-twc]').forEach(initTeamwearCatalogue);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-twc]').forEach(initTeamwearCatalogue));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-teamwear"] && !Shopify.designMode) return;
  try {
    
const teamwearBrandParam=new URLSearchParams(window.location.search).get('teamwear_brand');const teamwearBrandSelect=document.getElementById('tw-brand');if(teamwearBrandSelect&&[...teamwearBrandSelect.options].some(o=>o.value===teamwearBrandParam))teamwearBrandSelect.value=teamwearBrandParam;
document.addEventListener('click',function(event){const link=event.target.closest('[data-teamwear-brand]');if(!link)return;const select=document.getElementById('tw-brand');if(select){select.value=link.dataset.teamwearBrand;select.dispatchEvent(new Event('change',{bubbles:true}));}});

  } catch(e) { console.error(e); }
})();
})();
